export default "__VITE_ASSET__DJz2fP_K__"